import {createJSONStorage, persist} from "zustand/middleware";
import {create} from "zustand/react";
import {AllDictVO} from "@/service/dict.s";
import {filter, keyBy, merge, values} from "lodash";
import {LabelValuePO} from "@/model/workflow";

export interface TableFilterButtonType {
    title: string;
    attr: string;
    tag?: number;
    type?: "input" | "select" | "dateRange";
    key?: string | "user" | "location";
    width?: number;
    defaultValue?: LabelValuePO
    items?: AllDictVO[];
}

enum DataGridEnum {
    TableFilterItems = "tableFilters",
}

const defaultFilterItem: { [key: string]: TableFilterButtonType } = {
    dealTime: {title: "成交日期", attr: "dealTime", type: "dateRange", tag: 0, key: ""},
    urgeLastTime: {title: "上次催办时间", attr: "urgeLastTime", type: "dateRange", tag: 0, key: ""},
    createdAt: {title: "创建时间", attr: "createdAt", type: "dateRange", tag: 0, key: ""},
    paybackDate: {title: "回款时间", attr: "paybackDate", type: "dateRange", tag: 0, key: ""},
    dealDate: {title: "预计成交时间", attr: "dealDate", type: "dateRange", tag: 0, key: ""},
    paymentMethodId: {title: "回款方式", attr: "paymentMethodId", type: "select", tag: 0, key: "paymentMethod"},
    processClassify: {title: "流程分类", attr: "classifyId", type: "select", tag: -1, key: "processClassify"},
    industryId: {title: "所属行业", attr: "industryId", type: "select", tag: -1, key: "industry"},
    locationId: {title: "所在地区", attr: "locationId", type: "select", tag: 0, key: 'location'},
    userId: {title: "员工", attr: "creatorId", type: "select", key: "user", tag: -1,},
    createId: {title: "创建人", attr: "createId", type: "select", key: "user", tag: -1,},
    creatorId: {title: "业务人员", attr: "creatorId", type: "select", key: "seller", tag: -1,},
    directorId: {title: "负责人", attr: "creatorId", type: "select", key: "seller", tag: -1,},
    invoiceTypeId: {title: "开票类型", attr: "invoiceTypeId", type: "select", tag: 0, key: "invoiceType"},
    receivingMethodId: {title: "到账公司", attr: "receivingMethodId", type: "select", tag: 0, key: "receivingMethod"},
    planStatusId: {title: "目标状态", attr: "statusId", type: "select", tag: 0, key: "planStatus"},
    planTime: {title: "预计起止时间", attr: "planTime", type: "dateRange", tag: 0, key: ""},
    taskTime: {title: "起止时间", attr: "taskTime", type: "dateRange", tag: 0, key: ""},
    taskStatusId: {title: "任务状态", attr: "statusId", type: "select", tag: 0, key: "taskStatus"},
    stageId: {title: "商机阶段", attr: "stageId", type: "select", tag: 0, key: "stage"},
    priorityId: {title: "优先级", attr: "priorityId", type: "select", tag: 0, key: "taskPriority"},
    worktimeCategoryId: {title: "工时类别", attr: "categoryId", type: "select", tag: 0, key: "worktimeType"},
    patentStatusId: {title: "案件状态", attr: "patentStatusId", type: "select", tag: 0, key: "patentStatus"},
    projectStatusId: {title: "申报状态", attr: "projectStatusId", type: "select", tag: 0, key: "projectStatus"},
    trademarkStatusId: {title: "商标状态", attr: "trademarkStatusId", type: "select", tag: 0, key: "trademarkStatus"},
    noticeApplyType: {title: "申请类型", attr: "noticeApplyType", type: "select", tag: 0, key: "reqType"},
    postType: {title: "电子发文类型", attr: "type", type: "select", tag: 0, key: "postType"},
    contractType: {title: "合同类型", attr: "productTypeIds", type: "select", tag: 0, key: "contractType"},
    postDate: {title: "发文日期", attr: "postDate", type: "dateRange", tag: 0, key: ""},
    projectApplyDate: {title: "提报日期", attr: "applyDate", type: "dateRange", tag: 0, key: ""},
    patentApplyDate: {title: "申请日期", attr: "applyDate", type: "dateRange", tag: 0, key: ""},
    payTime: {title: "支出时间", attr: "payTime", type: "dateRange", tag: 0, key: ""},
    inventionName: {title: "发明创造名称", attr: "famingczmc", type: "input", tag: 0, key: "", width: 160},
    applicationNumber: {title: "申请号", attr: "applicationnumber", type: "input", tag: 0, key: "", width: 124},
    confirmStatus: {title: "确认状态", attr: "isDownload", type: "select", tag: 0, key: "confirmStatus"},
    noticeName: {title: "通知书名称", attr: "tongzhismc", type: "select", tag: 0, key: "patentStatus"},
    applyNumber: {title: "申请号", attr: "shenqingh", type: "input", tag: 0, key: "", width: 124},
    postNumber: {title: "发文序号", attr: "fawenxlh", type: "input", tag: 0, key: "", width: 124},
    downloadStatus: {title: "下载状态", attr: "xiazaizt", type: "select", tag: 0, key: "downloadStatus"},
    gender: {title: "性别", attr: "gender", type: "select", tag: 0, key: "gender"},
    sellerId: {title: "业务人员", attr: "sellerId", type: "select", key: "seller", tag: -1,},
    termLevel: {title: "政策级别", attr: "levelId", type: "select", key: "termLevel", tag: 0,},
    termSection: {title: "受理部门", attr: "sectionId", type: "select", key: "termSection", tag: 0,},
    copyrightStatusId: {title: "版权状态", attr: "copyrightStatusId", type: "select", tag: 0, key: "copyrightStatus"},
    copyrightCategoryId: {title: "版权类型", attr: "categoryId", type: "select", tag: 0, key: "copyrightType"},
    copyrightKindId: {title: "服务类型", attr: "kindId", type: "select", tag: 0, key: "copyrightKind"},
    patentKindId: {title: "服务类型", attr: "kindId", type: "select", tag: 0, key: "patentKind"},
    projectKindId: {title: "服务类型", attr: "kindId", type: "select", tag: 0, key: "projectKind"},
    trademarkKindId: {title: "服务类型", attr: "kindId", type: "select", tag: 0, key: "trademarkKind"},
    projectCategoryId: {title: "政策项目类型", attr: "categoryId", type: "select", tag: 0, key: "projectType"},
    patentCategoryId: {title: "申请类型", attr: "categoryId", type: "select", tag: 0, key: "patentType"},
    trademarkCategoryId: {title: "商标类别", attr: "categoryId", type: "select", tag: 0, key: "trademarkType"},
    applyDate: {title: "申请日期", attr: "applyDate", type: "dateRange", tag: 0, key: ""},
    insideDeadline: {title: "内部期限", attr: "insideDeadline", type: "dateRange", tag: 0, key: ""},
    projectPublicityDate: {title: "公示日期", attr: "publicityDate", type: "dateRange", tag: 0, key: ""},
    projectWriterId: {title: "撰稿人", attr: "writerId", type: "select", tag: 0, key: "declarer"},
    patentWriterId: {title: "撰稿人", attr: "writerId", type: "select", tag: 0, key: "patenter"},

    recordWayId: {title: "跟进方式", attr: "wayId", type: "select", tag: 0, key: "recordWay"},
    recordTypeId: {title: "跟进内容", attr: "typeId", type: "select", tag: 0, key: "recordType"},
    customerStatusId: {title: "客户状态", attr: "statusId", type: "select", tag: 0, key: "customerStatus"},
    projectValidDate: {title: "资质有效截止时间", attr: "validDate", type: "dateRange", tag: 0, key: ""},
    patentDeadline: {title: "最后期限", attr: "deadline", type: "dateRange", tag: 0, key: ""},
    summaryType: {title: "总结类型", attr: "summaryTypeId", type: "select", tag: 0, key: "summaryType"},
    travelTime: {title: "出行时间", attr: "travelTime", type: "dateRange", tag: 0, key: ""},
    leaveCategory: {title: "请假类别", attr: "leaveCategory", type: "select", tag: 0, key: "leaveCategory"},
    writeStatusId: {title: "撰写状态", attr: "writeStatusId", type: "select", tag: 0, key: "writeStatus"},
    firstContact: {title: "首要联系人", attr: "firsted", type: "select", tag: 0, key: "boole"},
    remindType: {title: "提醒类型", attr: "status", type: "select", tag: 0, key: "remindType", defaultValue: {label: "预先提醒", value: 1}},
}

const getDefaultFilter = (items: string[], tag = 0): TableFilterButtonType[] => {
    return items.map(item => ({...defaultFilterItem[item], tag}))
}

// Items
const initContractFilterItems: string[] = ["dealTime", "contractType", 'dealTime',];

const initPoolFilterItems: string[] = ["createdAt"]

const initCertFilterItems: string[] = ["inventionName", "applyNumber", "downloadStatus"]

const initPaybackedFilterItems: string[] = ["paybackDate", "paymentMethodId"]

const initUnpaybackFilterItems: string[] = ["paybackDate", "paymentMethodId"]

const initChanceFilterItems: string[] = ["dealDate", "createdAt", "stageId"];

const iniProjectDefendFilterItems: string[] = ["projectValidDate", "projectStatusId"];

const initForeheadFilterItems: string[] = ["createdAt"]

const initExpenseFilterItems: string[] = ["payTime", "createdAt"]

const initCustomerFilterItems: string[] = ["customerStatusId", "locationId", "directorId"];

const initInvoiceFilterItems: string[] = ["invoiceTypeId", "receivingMethodId"];

const initPlanFilterItems: string[] = ["planStatusId", "planTime"];

const initTermFilterItems: string[] = ["termLevel", "termSection"];

const initWorktimeFilterItems: string[] = ["worktimeCategoryId"];

const initReportFilterItems: string[] = ["priorityId"];

const initAcceptingFilterItems: string[] = ["priorityId"];

const initTaskFilterItems: string[] = ["taskStatusId", "taskTime"];

const initCaseWhseFilterItems: string[] = ["patentStatusId", "writeStatusId", "applyDate"];

const initAllProjectFilterItems: string[] = ["projectStatusId", "projectCategoryId", "writeStatusId"];

const initDutyProjectFilterItems: string[] = ["projectStatusId", "projectCategoryId", "writeStatusId"];

const initAllTrademarkFilterItems: string[] = ["trademarkStatusId", "writeStatusId", "sellerId"];

const initPaymentFilterItems: string[] = ["receivingMethodId", "creatorId"];

const initContactFilterItems: string[] = ["gender", "createdAt", "firstContact"];

const initRecordFilterItems: string[] = ["recordTypeId", "recordWayId"];

const initApprovalFilterItems: string[] = ["urgeLastTime", "createId", "processClassify"];

const initAllCopyrightFilterItems: string[] = ["copyrightStatusId", "copyrightCategoryId", "writeStatusId"];

const initReminderFilterItems: string[] = ["patentStatusId", "patentApplyDate", "sellerId", "remindType"];

const initPatentMonitorFilterItems: string[] = ["patentStatusId", "patentDeadline", "sellerId"];

const initSummaryFilterItems: string[] = ["createdAt", "summaryType", "userId"];

const initFieldworkFilterItems: string[] = ["travelTime", "sellerId"];

const initLeaveFilterItems: string[] = ["leaveCategory", "userId"];

const initUnclaimCopyrightFilterItems: string[] = ["copyrightCategoryId", "copyrightKindId"];

const initUnclaimProjectFilterItems: string[] = ["projectCategoryId", "projectKindId"];

const initUnclaimTrademarkFilterItems: string[] = ["trademarkCategoryId", "trademarkKindId"];

const initUnclaimCaseFilterItems: string[] = ["patentCategoryId", "patentKindId"];

const initDutyCaseFilterItems: string[] = ["patentCategoryId", "writeStatusId", "patentStatusId"]


// Pannel
const initContractFilterPannel: string[] = ["creatorId", "createdAt"];

const initAllProjectFilterPannel: string[] = ["sellerId", "projectPublicityDate", "projectWriterId", "applyDate"];

const initDutyProjectFilterPannel: string[] = ["sellerId", "projectPublicityDate", "projectWriterId", "applyDate"];

const initCustomerFilterPannel: string[] = ["industryId"];

const initPaybackFilterPannel: string[] = ["creatorId"];

const initInvoiceFilterPannel: string[] = ["creatorId"];

const initLetterFilterItems = ['inventionName', "applicationNumber", "postType", "confirmStatus", "noticeName"]

const initLetterFilterPannel: string[] = ["postDate", "noticeApplyType",];

const initCertFilterPannel: string[] = ['postNumber', "postDate"]

const initDutyCaseFilterPannel: string[] = ["patentKindId", "sellerId", "applyDate"]

const initUnclaimCaseFilterPannel: string[] = ["insideDeadline"]

const initUnclaimProjectFilterPannel: string[] = ["insideDeadline"]

const initUnclaimTrademarkFilterPannel: string[] = ["insideDeadline"]

const initUnclaimCopyrightFilterPannel: string[] = ["insideDeadline"]

const initCaseWhseFilterPannel: string[] = ["insideDeadline", "sellerId", "patentCategoryId", "patentWriterId"];

const initAllCopyrightFilterPannel: string[] = ["sellerId"];

const initApprovalFilterPannel: string[] = ["createdAt"];

type DataGridStore = {
    tableFilterItems: {
        [key: string]: TableFilterButtonType[]
    };
    tableFilterPannel: {
        [key: string]: TableFilterButtonType[]
    };
    searchParam: { [key: string]: any },
    actions: {
        setTableFilterItems: (code: string, items: TableFilterButtonType[]) => void;
        setTableFilterPannel: (
            code: string,
            items: TableFilterButtonType[],
        ) => void;
        setSearchParam: (code: string, param: any) => void;
    };
}

const useDataGridStore = create<DataGridStore>()(
    persist(
        (set) => ({
            searchParam: {},
            tableFilterItems: {
                customer: getDefaultFilter(initCustomerFilterItems),
                pool: getDefaultFilter(initPoolFilterItems),
                chance: getDefaultFilter(initChanceFilterItems),
                contract: getDefaultFilter(initContractFilterItems),
                paybacked: getDefaultFilter(initPaybackedFilterItems),
                unpayback: getDefaultFilter(initUnpaybackFilterItems),
                invoice: getDefaultFilter(initInvoiceFilterItems),
                plan: getDefaultFilter(initPlanFilterItems),
                task: getDefaultFilter(initTaskFilterItems),
                report: getDefaultFilter(initReportFilterItems),
                worktime: getDefaultFilter(initWorktimeFilterItems),
                accepting: getDefaultFilter(initAcceptingFilterItems),
                case_whse: getDefaultFilter(initCaseWhseFilterItems),
                all_project: getDefaultFilter(initAllProjectFilterItems),
                duty_project: getDefaultFilter(initDutyProjectFilterItems),
                all_copyright: getDefaultFilter(initAllCopyrightFilterItems),
                payment: getDefaultFilter(initPaymentFilterItems),
                all_trademark: getDefaultFilter(initAllTrademarkFilterItems),
                patent_letter: getDefaultFilter(initLetterFilterItems),
                patent_cert: getDefaultFilter(initCertFilterItems),
                contact: getDefaultFilter(initContactFilterItems),
                term: getDefaultFilter(initTermFilterItems),
                record: getDefaultFilter(initRecordFilterItems),
                forehead: getDefaultFilter(initForeheadFilterItems),
                expense: getDefaultFilter(initExpenseFilterItems),
                defend_project: getDefaultFilter(iniProjectDefendFilterItems),
                reminder: getDefaultFilter(initReminderFilterItems),
                patent_monitor: getDefaultFilter(initPatentMonitorFilterItems),
                summary: getDefaultFilter(initSummaryFilterItems),
                fieldwork: getDefaultFilter(initFieldworkFilterItems),
                leave: getDefaultFilter(initLeaveFilterItems),
                unclaim_copyright: getDefaultFilter(initUnclaimCopyrightFilterItems),
                unclaim_project: getDefaultFilter(initUnclaimProjectFilterItems),
                unclaim_case: getDefaultFilter(initUnclaimCaseFilterItems),
                unclaim_trademark: getDefaultFilter(initUnclaimTrademarkFilterItems),
                duty_case: getDefaultFilter(initDutyCaseFilterItems),
                approval: getDefaultFilter(initApprovalFilterItems)
            },
            tableFilterPannel: {
                contract: getDefaultFilter(initContractFilterPannel, -1),
                customer: getDefaultFilter(initCustomerFilterPannel, -1),
                payback: getDefaultFilter(initPaybackFilterPannel, -1),
                invoice: getDefaultFilter(initInvoiceFilterPannel, -1),
                patent_letter: getDefaultFilter(initLetterFilterPannel, -1),
                patent_cert: getDefaultFilter(initCertFilterPannel, -1),
                all_project: getDefaultFilter(initAllProjectFilterPannel, -1),
                duty_project: getDefaultFilter(initDutyProjectFilterPannel, -1),
                all_copyright: getDefaultFilter(initAllCopyrightFilterPannel, -1),

                duty_case: getDefaultFilter(initDutyCaseFilterPannel, -1),
                unclaim_case: getDefaultFilter(initUnclaimCaseFilterPannel, -1),
                unclaim_project: getDefaultFilter(initUnclaimProjectFilterPannel, -1),
                unclaim_trademark: getDefaultFilter(initUnclaimTrademarkFilterPannel, -1),
                unclaim_copyright: getDefaultFilter(initUnclaimCopyrightFilterPannel, -1),
                case_whse: getDefaultFilter(initCaseWhseFilterPannel, -1),
                approval: getDefaultFilter(initApprovalFilterPannel, -1)
            },
            actions: {
                setTableFilterItems: (code: string, items: TableFilterButtonType[]) =>
                    set((state) => ({
                        tableFilterItems: {...state.tableFilterItems, [code]: items},
                    })),
                setSearchParam: (code: string, param: any) => set((state) => ({
                    searchParam: {...state.searchParam, [code]: param},
                })),
                setTableFilterPannel: (code: string, items: TableFilterButtonType[]) =>
                    set((state) => ({
                        tableFilterPannel: {...state.tableFilterPannel, [code]: items},
                    })),
            },
        }),
        {
            name: "dataGridStore",
            storage: createJSONStorage(() => localStorage),
            partialize: (state) => ({
                [DataGridEnum.TableFilterItems]: state.tableFilterItems,
            }),
        },
    ),
);

export const useGetTableFilterItems = (code: string) => {
    const tableFilterItems = useTableFilterItems();
    return tableFilterItems[code];
};

export const useGetTableFilterPannel = (code: string) => {
    const tableFilterPannel = useTableFilterPannel();
    return tableFilterPannel[code];
};

export const useGetSearchParam = (code: string) => {
    const searchParam = useSearchParam();
    return searchParam[code] || {};
}

export const useTableFilterItems = () =>
    useDataGridStore((state) => state.tableFilterItems);

export const useSearchParam = () =>
    useDataGridStore((state) => state.searchParam);

export const useTableFilterPannel = () =>
    useDataGridStore((state) => state.tableFilterPannel);

export const useSetTableFilterItems = (code: string) => {
    const tableFilterItems: TableFilterButtonType[] =
        useGetTableFilterItems(code);
    const tableFilterPannel: TableFilterButtonType[] =
        useGetTableFilterPannel(code);
    const {setTableFilterItems, setTableFilterPannel} = useDataGridActions();

    const saveTableFilterItems = (item: TableFilterButtonType) => {
        if (item.tag == -1) {
            const filteredFilterItems = filter(
                tableFilterItems,
                (ele) => ele.attr != item.attr,
            );
            setTableFilterItems(code, filteredFilterItems);
        } else {
            const mergedFilterItems = merge(keyBy(tableFilterItems, "attr"), {
                [item.attr]: item,
            });
            setTableFilterItems(code, values(mergedFilterItems));
        }

        const mergedFilterPannel = merge(keyBy(tableFilterPannel, "attr"), {
            [item.attr]: item,
        });
        setTableFilterPannel(code, values(mergedFilterPannel));
    };
    return saveTableFilterItems;
};

export const useDataGridActions = () =>
    useDataGridStore((state) => state.actions);
